<template>
  <div class="App-termsService bg-white">
    <div class="inner text-center">
      <h1 class="h1 title">{{$t('terms.title')}}</h1>
      <div class="content text-left">
        <div class="lead mb-50">{{$t('terms.lead')}}</div>
        <div class="title-mini">{{$t('terms.title1')}}</div>
        <div class="text" v-html="$t('terms.text1')"></div>
        <div class="title-mini">{{$t('terms.title2')}}</div>
        <div class="text">{{$t('terms.text2')}}</div>
        <div class="title-mini">{{$t('terms.title3')}}</div>
        <div class="text">{{$t('terms.text3')}}</div>
        <div class="title-mini">{{$t('terms.title4')}}</div>
        <div class="text">{{$t('terms.text4')}}</div>
        <div class="title-mini">{{$t('terms.title5')}}</div>
        <div class="text">{{$t('terms.text5')}}</div>
        <div class="title-mini">{{$t('terms.title6')}}</div>
        <div class="text">{{$t('terms.text6')}}</div>
        <div class="title-mini">{{$t('terms.title7')}}</div>
        <div class="text">{{$t('terms.text7')}}</div>
        <div class="title-mini">{{$t('terms.title8')}}</div>
        <div class="text">{{$t('terms.text8')}}</div>
        <div class="title-mini">{{$t('terms.title9')}}</div>
        <div class="text">{{$t('terms.text9')}}</div>
        <div class="title-mini">{{$t('terms.title10')}}</div>
        <div class="text">{{$t('terms.text10')}}</div>
        <div class="title-mini">{{$t('terms.title11')}}</div>
        <div class="text">{{$t('terms.text11')}}</div>
        <div class="title-mini">{{$t('terms.title12')}}</div>
        <div class="text">{{$t('terms.text12')}}</div>
        <div class="title-mini">{{$t('terms.title13')}}</div>
        <div class="text">{{$t('terms.text13')}}</div>
        <div class="title-mini">{{$t('terms.title14')}}</div>
        <div class="text">{{$t('terms.text14')}}</div>
        <div class="title-mini">{{$t('terms.title15')}}</div>
        <div class="text">{{$t('terms.text15')}}</div>
        <div class="title-mini">{{$t('terms.title16')}}</div>
        <div class="text">{{$t('terms.text16')}}</div>
        <div class="title-mini">{{$t('terms.title17')}}</div>
        <div class="text">{{$t('terms.text17')}}</div>
        <div class="title-mini">{{$t('terms.title18')}}</div>
        <div class="text">{{$t('terms.text18')}}</div>
        <div class="title-mini">{{$t('terms.title19')}}</div>
        <div class="text">{{$t('terms.text19')}}</div>
        <div class="title-mini">{{$t('terms.title20')}}</div>
        <div class="text" v-html="$t('terms.text20')"></div>
        <div class="title-mini">{{$t('terms.title21')}}</div>
        <div class="text">{{$t('terms.text21')}}</div>
        <div class="title-mini">{{$t('terms.title22')}}</div>
        <div class="text">{{$t('terms.text22')}}</div>
        <div class="title-mini">{{$t('terms.title23')}}</div>
        <div class="text">{{$t('terms.text23')}}</div>
        <div class="title-mini">{{$t('terms.title24')}}</div>
        <div class="text">{{$t('terms.text24')}}</div>
        <div class="title-mini">{{$t('terms.title25')}}</div>
        <div class="text">{{$t('terms.text25')}}</div>
        <div class="title-mini">{{$t('terms.title26')}}</div>
        <div class="text">{{$t('terms.text26')}}</div>
        <div class="date">{{$t('terms.date')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
  import { META_TERMSSERVICE } from '../../mixins/metadata.js'

  export default {
    mixins: [META_TERMSSERVICE],
    name: 'TermsServicePage',
    head: {
      title: {
        inner: '利用規約｜ZATSUDAN'
      },
      meta: [
        { name: 'keywords', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
        { name: 'description', content: '思いがけないアイデアと出会う。プロフェッショナル同士の予定調和のない雑談' },
      ]
    },
  }
</script>
<style scoped>
.text{
  white-space: pre-wrap;
}
</style>
